export default class GTMEvents {
    constructor() {
        this.events = {
            registrationDone: 'Registration_Done',
            subscriptionButton: 'Subscription_Button',
            subscriptionDone: 'Subscription_Done',
            PMfrmSubscribe: 'PMfrmSubscribe',
            add2CartButton: 'Add2Cart_Button',
            oneClickBuyButton: 'oneClick_buy_Button',
            accessoriesTab: 'accessories_tab',
            faqTab: 'faq_tab',
            reviewsTab: 'reviews_tab',
            descriptionTab: 'description_tab',
            onlineConsultant: 'online_consultant',
            onlineConsultantButton: 'online_consultant_button',
            onlineConsultantSent: 'online_consultant_sent',
            backcall: 'backcall',
            backcallButton: 'backcall_button',
            backcallSent: 'backcall_sent',
            claimButton: 'claim_button',
            claimDone: 'claim_Done',
            basketRefresh: 'basket_refresh',
            basketOrder: 'basket_order',
            contactLogin: 'contact_login',
            contact1clickBuy: 'contact_1clickBuy',
            contactRegistration: 'contact_registration',
            contactRegistrationContinue: 'contact_registration_continue',
            contactLoginContinue: 'contact_login_continue',
            contact1clickBuyContinue: 'contact_1clickBuy_continue',
            confirmOrder: 'confirm_order',
            PMbtnSocial: 'PMbtnSocial',
            PMbtnFAQ: 'PMbtnFAQ',
            PMfrmFAQ: 'PMfrmFAQ',
            PMbtnCallMe: 'PMbtnCallMe',
            PMfrmCallMe: 'PMfrmCallMe',
            PMbtnReg: 'PMbtnReg',
            PMfrmReg: 'PMfrmReg',
            PMbtnSelectCity: 'PMbtnSelectCity',
            PMbtnTellAbout: 'PMbtnTellAbout',
            PMbtnContact: 'PMbtnContact',
            PMbtnComment: 'PMbtnComment',
            PMfrmComment: 'PMfrmComment',
            PMbtnAskQuestion: 'PMbtnAskQuestion',
            PMfrmAskQuestion: 'PMfrmAskQuestion',
            PMbtn1Click: 'PMbtn1Click',
            PMfrm1Click: 'PMfrm1Click',
            PMbtnFavorite: 'PMbtnFavorite',
            PMbtnAddToCart: 'PMbtnAddToCart',
            PMbtnTabs: 'PMbtnTabs',
            PMbtnTel: 'PMbtnTel',
            PMfrmCallMeContact: 'PMfrmCallMeContact',
            PMbtnVariant: 'PMbtnVariant',
            PMbtnFilter: 'PMbtnFilter',
            ecommercePromoClick: 'ecommercePromoClick',
            ecommercePromoView: 'ecommercePromoView',
            ecommerceImpressions: 'ecommerceImpressions',
            ecommerceClick: 'ecommerceClick',
            ecommerceDetail: 'ecommerceDetail',
            ecommerceAdd: 'ecommerceAdd',
            ecommerceRemove: 'ecommerceRemove',
            ecommerceCheckout: 'ecommerceCheckout',
            completeRegistration: 'CompleteRegistration'
        };
    }

    onAddToCart(arg) {
        if (arg) {
            this.push({
                event: 'addToCart',
                ...arg
            });
            return;
        }
        this.pushEvent('add2CartButton');
    }

    onSignUpEnd(event) {
        this.pushEvent(event);
    }

    onCheckoutEnd() {
        this.pushEvent('confirmOrder');
    }

    onAdviserWindow() {
        this.pushEvent('onlineConsultant');
    }

    onAdviserReply() {
        this.pushEvent('onlineConsultantButton');
    }

    onFeedbackSend() {
        this.pushEvent('claimButton');
    }

    onTabClick(tab) {
        const tabMap = {
            descr: 'descriptionTab',
            reviews: 'reviewsTab',
            faq: 'faqTab',
            login: 'contactLogin',
            reg: 'contactRegistration',
            oneclick: 'contact1clickBuy'
        };

        if (!tabMap[tab]) {
            return;
        }

        this.pushEvent(tabMap[tab]);
    }

    onSubscribe() {
        this.pushEvent('subscriptionButton');
    }

    onSubscriptionDone() {
        this.pushEvent('subscriptionDone');
    }

    onPMfrmSubscribe() {
        this.pushEvent('PMfrmSubscribe');
    }

    PMbtnTel() {
        this.pushEvent('PMbtnTel');
    }

    onCallBackFormShow() {
        this.pushEvent('backcall');
    }

    onCallBackButton() {
        this.pushEvent('backcallButton');
    }

    onCallBackRequestSend() {
        this.pushEvent('backcallSent');
    }

    onCheckoutStart() {
        this.pushEvent('basketOrder');
    }

    onBasketRefresh() {
        this.pushEvent('basketRefresh');
    }

    onOneClickBuyButton() {
        this.pushEvent('oneClickBuyButton');
    }

    onOneClickBuyEnd() {
        this.pushEvent('contact1clickBuyContinue');
    }

    PMbtnSocial(arg) {
        this.push({
            event: 'PMbtnSocial',
            ...arg
        });
    }

    PMbtnVariant(arg) {
        this.push({
            event: 'PMbtnVariant',
            ...arg
        });
    }

    PMfrmCallMeContact(arg) {
        this.push({
            event: 'PMfrmCallMeContact',
            ...arg
        });
    }

    PMbtnTabs(arg) {
        this.push({
            event: 'PMbtnTabs',
            ...arg
        });
    }

    PMbtnAddToCart(arg) {
        this.push({
            event: 'PMbtnAddToCart',
            ...arg
        });
    }

    PMbtnSelectCity(arg) {
        this.push({
            event: 'PMbtnSelectCity',
            ...arg
        });
    }

    PMbtnTellAbout(arg) {
        this.push({
            event: 'PMbtnTellAbout',
            ...arg
        });
    }

    PMbtn1Click() {
        this.push({
            event: 'PMbtn1Click'
        });
    }

    PMfrm1Click(arg) {
        this.push({
            event: 'PMfrm1Click',
            ...arg
        });
    }

    PMbtnFavorite(arg) {
        this.push({
            event: 'PMbtnFavorite',
            ...arg
        });
    }

    PMbtnContact(arg) {
        this.push({
            event: 'PMbtnContact',
            ...arg
        });
    }

    PMbtnFAQ() {
        this.push({
            event: 'PMbtnFAQ'
        });
    }

    PMfrmFAQ() {
        this.push({
            event: 'PMfrmFAQ'
        });
    }

    PMbtnCallMe() {
        this.push({
            event: 'PMbtnCallMe'
        });
    }

    PMfrmCallMe() {
        this.push({
            event: 'PMfrmCallMe'
        });
    }

    PMbtnFilter() {
        this.push({
            event: 'PMbtnFilter'
        });
    }

    PMbtnReg() {
        this.push({
            event: 'PMbtnReg'
        });
    }

    PMfrmReg() {
        this.push({
            event: 'PMfrmReg'
        });
    }

    PMbtnComment() {
        this.push({
            event: 'PMbtnComment'
        });
    }

    PMfrmComment() {
        this.push({
            event: 'PMfrmComment'
        });
    }

    PMbtnAskQuestion() {
        this.push({
            event: 'PMbtnAskQuestion'
        });
    }

    PMfrmAskQuestion() {
        this.push({
            event: 'PMfrmAskQuestion'
        });
    }

    pushEvent(eventName) {
        if (this.events[eventName] !== undefined) {
            this.push({
                event: this.events[eventName]
            });
        }
    }

    ecommercePromoClick(arg) {
        this.push({
            event: 'ecommercePromoClick',
            ...arg
        });
    }

    ecommercePromoView(arg) {
        this.push({
            event: 'ecommercePromoView',
            ...arg
        });
    }

    ecommerceImpressions(arg) {
        this.push({
            event: 'ecommerceImpressions',
            ...arg
        });
    }

    ecommerceClick(arg) {
        this.push({
            event: 'ecommerceClick',
            ...arg
        });
    }

    ecommerceDetail(arg) {
        this.push({
            event: 'ecommerceDetail',
            ...arg
        });
    }

    ecommerceAdd(arg) {
        this.push({
            event: 'ecommerceAdd',
            ...arg
        });
    }

    ecommerceRemove(arg) {
        this.push({
            event: 'ecommerceRemove',
            ...arg
        });
    }

    ecommerceCheckout(arg) {
        this.push({
            event: 'ecommerceCheckout',
            ...arg
        });
    }

    push(params) {
        window.dataLayer.push(params);
    }
}



// WEBPACK FOOTER //
// ./blocks/tracker/gtm.js